import { ROUTES } from 'constants/routesConstants'

export const isAnyOfCheckoutRoutes = (pathname: string) => {
	return (
		[
			ROUTES.checkout.index,
			ROUTES.checkout.plans,
			ROUTES.checkout.upgrade,
		] as string[]
	).includes(pathname)
}

export const isAnyOfPrivatePricingRoutes = (pathname: string) => {
	return ([ROUTES.plans, ROUTES.pricing] as string[]).includes(pathname)
}

export const isAnyOfPurchaseLayoutRoutes = (pathname: string) => {
	return (
		isAnyOfPrivatePricingRoutes(pathname) || isAnyOfCheckoutRoutes(pathname)
	)
}

export const isPricingOrCheckout = (pathname: string) => {
	return ([ROUTES.pricing, ROUTES.checkout.index] as string[]).includes(
		pathname,
	)
}
